import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import AdminDashboard from '../components/AdminDashboard';
import StudentDashboard from '../components/StudentDashboard';

const Dashboard = () => {
    const { user } = useContext(AuthContext);

    if (!user) {
        return (
            <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 rounded-3xl bg-white/70 p-12 text-center shadow-xl backdrop-blur">
                <div className="h-12 w-12 animate-spin rounded-full border-4 border-indigo-200 border-t-indigo-500" aria-hidden />
                <p className="text-lg font-medium text-slate-700">Đang tải dữ liệu người dùng...</p>
            </div>
        );
    }

    return (
        <div className="space-y-12 rounded-3xl bg-white/80 p-8 shadow-xl backdrop-blur">
            <div className="flex flex-col gap-6 rounded-2xl bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 p-8 text-white shadow-lg md:flex-row md:items-center md:justify-between">
                <div>
                    <h1 className="flex items-center gap-3 text-3xl font-semibold">
                        <span role="img" aria-hidden>👋</span>
                        Chào mừng trở lại!
                    </h1>
                    <p className="mt-3 max-w-2xl text-base text-indigo-100">
                        Xin chào <strong>{user.name}</strong>,
                        {user.role === 'admin'
                            ? ' bạn đang quản lý hệ thống học tập.'
                            : ' hãy tiếp tục hành trình học tập của bạn!'}
                    </p>
                </div>
                <div className="flex items-center gap-4 rounded-2xl bg-white/15 px-6 py-4 text-sm font-semibold uppercase tracking-wide">
                    <span className="text-3xl" role="img" aria-hidden>
                        {user.role === 'admin' ? '👨‍💼' : '👨‍🎓'}
                    </span>
                    <span>{user.role === 'admin' ? 'Quản trị viên' : 'Học sinh'}</span>
                </div>
            </div>

            <div>
                {user.role === 'admin' ? <AdminDashboard /> : <StudentDashboard />}
            </div>
        </div>
    );
};

export default Dashboard;